import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './emailSuggestion.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/Floating/Menu";
import "../../../moreCore/UI/Container/ExpandableSectionTypes";
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { EmailEditorTypes } from "../emailTypes";
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";

class emailSuggestion extends compose(_GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private selectedMails: Array<string>;

    private mailSuggestionData: EmailEditorTypes.mailDataForSuggestion;

    private excludedMails: Array<string> = [];

    private mailFormContext: EmailEditorTypes.mailFormContext;

    public constructor(mailFormContext: EmailEditorTypes.mailFormContext) {
        super(...(arguments as unknown as []));
        this.selectedMails = [];
        this.mailFormContext = mailFormContext;
    }

    public setMailFormContext(mailFormContext: EmailEditorTypes.mailFormContext) {
        this.mailFormContext = mailFormContext;
    }

    public setExcludedMails(excludeMe:Array<string>){
        this.excludedMails = [];
        this.excludedMails = excludeMe;
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    //#region postCreate
    postCreate(): void {
        this.SEDconfigCallfunction = "Webtool_API_EmailTransmission_MailSuggestion___GetSEDconfig";
    }

    public openDlg(ev: MouseEvent){
        this.loadSelectEntityDialog(
            ev,
            this["declaredClass"], 
            lang.hitch(this, this._dlgCallback ),
            null,
            this.mailFormContext,
            true // force reload, weil bereits eingefügte Mailadressen können sich geändert haben
        );
    }

    private _dlgCallback(mode: Array<object>, data: Array<object>, items: Array<SelectEntityDialogTypes.Item<any>>) {
        let selectedMails: Array<EmailEditorTypes.mailRecipient> = [];
        if (items?.length) {
            for (let item of items) {
                let pickedMail = item.entry.secondaryLabel;
                let pickedValue = item.entry.value;

                if (pickedMail) {
                    //check ob die email in der gefilterten liste ist (dann wurde sie warscheinlich bereits hinzugefuegt)
                    let canAdd = true;
                    if (this.excludedMails?.length) {
                        for (let filteredMail of this.excludedMails) {
                            if (filteredMail.toLowerCase() == pickedMail.toLowerCase()) {
                                canAdd = false;
                                break;
                            }
                        }
                    }
                    if (canAdd === true) {
                       

                        switch (item.sourceTree) {
                            case "fromHistory":
                                pickedMail = item.entry.label;
                                // Achtung, dann ist das Objekt aus den beteiligten Adressen, nicht aus Telekom!
                                // die API bereinigt die Ergebnisse von Dubletten und schickt kein Entity mit
                                // wir erkennen nur anhand der Value, ob wir eine ID erhalten oder nicht
                                if (pickedMail == pickedValue) { // bei "roten" Einträgen sind value und label identisch
                                    pickedValue = null;
                                }
                                break;

                            default:
                                
                               
                                break;
                        }

                        let newEntry: EmailEditorTypes.mailRecipient = {
                            mailaddress: pickedMail,
                            entityID: pickedValue
                        }
                        selectedMails.push(newEntry);
                    }
                }

               

            }

            this.emit("select", selectedMails);
        }
        
    }

    //#region get Suggest.
    public getCollectedSuggestions(): Array<string> {
        //this.collectMailSuggestions(); <- email wurden bereits gefilteret mit den excluded mails
        return this.selectedMails;
    }

    
    
}

export default mdsWidget(emailSuggestion);


/*
TODO list
* more feature checks?

/*
Translations benutzt im back-end:
email_mailSearch_popup_tab_fromProject (Webtool_API_EmailTransmission_MailSuggestion___GetSEDconfig)
email_emailSuggestion_fromProject_tab_lable (Webtool_API_EmailTransmission_MailSuggestion___GetSEDconfig)
email_emailSuggestion_tab_title (Webtool_API_EmailTransmission_MailSuggestion___GetSEDconfig)
email_emailSuggestion_fromHistory_tab_lable
*/
